<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <!-- <Divider orientation="left">加分材料</Divider> -->
    <Row :gutter="16">
      <Col span="24">
      <List border item-layout="vertical">
        <!-- 职称材料 -->
        <ListItem v-if="form.hasPlusTitle">
          <ListItemMeta>
            <template #title>
              <li>
                职称材料
              </li>
            </template>
            <!-- @on-change="(val)=>{collapse1=val}"  -->
            <template #description>
              <Collapse v-model.trim="collapse1" v-if="form.hasPlusTitle" :key="form.hasPlusTitle">
                <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse1'+index" v-for="(item,index) in form.plusTitleList" :key="'bonusMaterial1'+index">
                  职称材料{{index+1}}
                  <template #content>
                    <Row :gutter="16">
                      <Col span="12">
                      <FormItem :label="'职称'+(index+1)+'名称'">
                        <Input v-model.trim="form.plusTitleList[index].title" disabled>
                        </Input>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem label="是否注册类证书" :key='"plusTitleList["+index+"].isRegCert"'>
                        <RadioGroup v-model.trim="form.plusTitleList[index].isRegCert">
                          <Radio disabled :label="true">是</Radio>
                          <Radio disabled :label="false">否</Radio>
                        </RadioGroup>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'职称证书'+(index+1)" :key='"plusTitleList["+index+"].titleCertGuid"'>
                        <!-- :prop='"plusTitleList["+index+"].titleCertGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusTitleList[index].titleCertGuidPreview" :ref="'plusTitleList['+index+'].titleCertGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].titleCertGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].titleCertGuid`)"  :before-upload='(file)=>handleBefore(`plusTitleList[${index}].titleCertGuid`)'  :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusTitleList[index].titleCertGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusTitleList[index].titleCertGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'聘任表'+(index+1)">
                        <!-- :key='"plusTitleList["+index+"].appointmentFormGuid"' :prop='"plusTitleList["+index+"].appointmentFormGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusTitleList[index].appointmentFormGuidPreview" :ref="'plusTitleList['+index+'].appointmentFormGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'"
                          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].appointmentFormGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].appointmentFormGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].appointmentFormGuid`)'
                          :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusTitleList[index].appointmentFormGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                         <span class='_noLink' v-if="form.plusTitleList[index].appointmentFormGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'评审表/考试表'+(index+1)">
                        <!-- :prop='"plusTitleList["+index+"].reviewFormGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusTitleList[index].reviewFormGuidPreview" :ref="'plusTitleList['+index+'].reviewFormGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].reviewFormGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].reviewFormGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].reviewFormGuid`)'
                          :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusTitleList[index].reviewFormGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                         <span class='_noLink' v-if="form.plusTitleList[index].reviewFormGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>

                      <Col span="12" v-show="form.plusTitleList[index].isRegCert===true">
                      <FormItem :label="'注册证书'+(index+1)">
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusTitleList[index].regCertGuidPreview" :ref="'plusTitleList['+index+'].regCertGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-preview="handlePreview"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].regCertGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].regCertGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].regCertGuid`)'
                          :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusTitleList[index].regCertGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusTitleList[index].regCertGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'职称'+(index+1)+'补充材料'">
                        <!--  :prop='"plusTitleList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusTitleList[index].otherFileGuidListPreview" :ref="'plusTitleList['+index+'].otherFileGuidList'" :action="$baseURL+'/common/file/uploadfile'" :on-preview="handlePreview"
                          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].otherFileGuidList`,true)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusTitleList[index].otherFileGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusTitleList[index].otherFileGuidListPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                    </Row>
                  </template>
                </Panel>
              </Collapse>
            </template>
          </ListItemMeta>
        </ListItem>
        <!-- 技能等级材料 -->
        <ListItem v-if="form.hasPlusSkillLevel">
          <ListItemMeta>
            <template #title>
              <li>
                技能等级材料
              </li>
            </template>
            <template #description>
              <Collapse v-model.trim="collapse2" v-if="form.hasPlusSkillLevel" :key="form.hasPlusSkillLevel">
                <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse2'+index" v-for="(item,index) in form.plusSkillLevelList" :key="'bonusMaterial'+index">
                  技能等级材料{{index+1}}
                  <template #content>
                    <Row :gutter="16">
                      <Col span="12">
                      <FormItem :label="'技能等级'+(index+1)+'名称'">
                        <Input disabled v-model.trim="form.plusSkillLevelList[index].title">
                        </Input>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'技能等级证书'+(index+1)">
                        <!-- :prop='"plusSkillLevelList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusSkillLevelList[index].skillLevelCertGuidPreview" :on-preview="handlePreview" :ref="'plusSkillLevelList['+index+'].skillLevelCertGuid'" :action="$baseURL+'/common/file/uploadfile'"
                          :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusSkillLevelList[${index}].skillLevelCertGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusSkillLevelList[${index}].skillLevelCertGuid`)"
                          :before-upload='(file)=>handleBefore(`plusSkillLevelList[${index}].skillLevelCertGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusSkillLevelList[index].skillLevelCertGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusSkillLevelList[index].skillLevelCertGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'技能等级证书'+(index+1)+'补充材料'">
                        <!-- :prop='"plusSkillLevelList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusSkillLevelList[index].otherFileGuidListPreview" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusSkillLevelList[${index}].otherFileGuidList`,true)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusSkillLevelList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusSkillLevelList[index].otherFileGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusSkillLevelList[index].otherFileGuidListPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                    </Row>
                  </template>
                </Panel>
              </Collapse>
            </template>
          </ListItemMeta>
        </ListItem>
        <!--表彰奖励材料  -->
        <ListItem v-if="form.hasPlusRecognitionAward">
          <ListItemMeta>
            <template #title>
              <li>
                表彰奖励材料
              </li>
            </template>
            <template #description>
              <Collapse v-model.trim="collapse3" v-if="form.hasPlusRecognitionAward" :key="form.hasPlusRecognitionAward">
                <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse3'+index" v-for="(item,index) in form.plusRecognitionAwardList" :key="'bonusMaterial3'+index">
                  表彰奖励材料{{index+1}}
                  <template #content>
                    <Row :gutter="16">
                      <Col span="12">
                      <FormItem :label="'表彰奖励'+(index+1)+'名称'">
                        <Input v-model.trim="form.plusRecognitionAwardList[index].title" disabled>
                        </Input>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'表彰奖励'+(index+1)+'材料'">
                        <!-- :prop='"plusRecognitionAwardList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusRecognitionAwardList[index].recognitionAwardGuidPreview" :on-preview="handlePreview" :ref="'plusRecognitionAwardList['+index+'].recognitionAwardGuid'"
                          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusRecognitionAwardList[${index}].recognitionAwardGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusRecognitionAwardList[${index}].recognitionAwardGuid`)"
                          :before-upload='(file)=>handleBefore(`plusRecognitionAwardList[${index}].recognitionAwardGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusRecognitionAwardList[index].recognitionAwardGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusRecognitionAwardList[index].recognitionAwardGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'表彰奖励'+(index+1)+'补充材料'">
                        <!--  :prop='"plusRecognitionAwardList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusRecognitionAwardList[index].otherFileGuidListPreview" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusRecognitionAwardList[${index}].otherFileGuidList`,true)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusRecognitionAwardList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusRecognitionAwardList[index].otherFileGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusRecognitionAwardList[index].otherFileGuidListPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                    </Row>
                  </template>
                </Panel>
              </Collapse>
            </template>
          </ListItemMeta>
        </ListItem>
        <!-- 投资纳税带动本地就业材料 -->
        <ListItem v-if="form.hasPlusInvestmentTaxationDrivingLocalEmployment">
          <ListItemMeta>
            <template #title>
              <li>
                投资纳税带动本地就业材料
              </li>
            </template>
            <template #description>
              <Collapse v-model.trim="collapse4" v-if="form.hasPlusInvestmentTaxationDrivingLocalEmployment" :key="form.hasPlusInvestmentTaxationDrivingLocalEmployment">
                <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse4'+index" v-for="(item,index) in form.plusInvestmentTaxationDrivingLocalEmploymentList" :key="'bonusMaterial4'+index">
                  投资单位{{index+1}}
                  <template #content>
                    <Row :gutter="16">
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'名称'">
                        <Input v-model.trim="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].enterpriseName" disabled>
                        </Input>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'验资报告'">
                        <!--  :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].capitalVerificationReportGuidPreview" :on-preview="handlePreview"
                          :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].capitalVerificationReportGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)"
                          :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].capitalVerificationReportGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].capitalVerificationReportGuidPreview.length<1">无</span>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'工伤档案机读材料'">
                        <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].businessArchivesMachineReadGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].businessArchivesMachineReadGuidPreview" :on-preview="handlePreview"
                          :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].businessArchivesMachineReadGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)"
                          :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].businessArchivesMachineReadGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].businessArchivesMachineReadGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'近三年税单'">
                        <!--  :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].year3guid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxOfLastThreeYearGuidPreview" :on-preview="handlePreview"
                          :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].taxOfLastThreeYearGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)"
                          :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxOfLastThreeYearGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxOfLastThreeYearGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem label="上传材料">
                        <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].uptype"' :rules="{required: false, message:'请选择', trigger: 'blur'}" -->
                        <RadioGroup v-model.trim="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].uploadMaterialType">
                          <!-- <Radio label="连续三年本市税单明细>=10万证明材料">连续三年本市税单明细>=10万证明材料</Radio>
                          <Radio label="连续三年聘用本市户籍人员>=10证明材料(连续缴纳社保>=6个月)">连续三年聘用本市户籍人员>=10证明材料(连续缴纳社保>=6个月)</Radio> -->
                          <Radio :label="value" disabled v-for="{text,value} in $store.state.materiaBasicData.plusITDLEUploadMaterialType" :key="value">{{text}}</Radio>
                        </RadioGroup>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'近三年税单明细'">
                        <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].taxDetailOfLastThreeYearGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxDetailOfLastThreeYearGuidPreview" :on-preview="handlePreview"
                          :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].taxDetailOfLastThreeYearGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)"
                          :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxDetailOfLastThreeYearGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxDetailOfLastThreeYearGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'投资单位'+(index+1)+'近三年补充材料'">
                        <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].year3guidOther"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].otherFileGuidListPreview" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].otherFileGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].otherFileGuidListPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                    </Row>
                  </template>
                </Panel>
              </Collapse>
            </template>
          </ListItemMeta>
        </ListItem>
        <!--孵化器材料  -->
        <ListItem v-if="form.hasPlusIncubatorMaterial">
          <ListItemMeta>
            <template #title>
              <li>
                孵化器材料
              </li>
            </template>
            <template #description>
              <Collapse v-model.trim="collapse5" v-if="form.hasPlusIncubatorMaterial" :key="form.hasPlusIncubatorMaterial">
                <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse5'+index" v-for="(item,index) in form.plusIncubatorMaterialList" :key="'bonusMaterial5'+index">
                  孵化器{{index+1}}
                  <template #content>
                    <Row :gutter="16">
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'名称'">
                        <Input v-model.trim.trim="form.plusIncubatorMaterialList[index].title" disabled>
                        </Input>
                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'孵化协议'">
                        <!--  :prop='"plusIncubatorMaterialList["+index+"].incubationProtocolGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusIncubatorMaterialList[index].incubationProtocolGuidPreview" :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].incubationProtocolGuid'"
                          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].incubationProtocolGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].incubationProtocolGuid`)"
                          :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].incubationProtocolGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusIncubatorMaterialList[index].incubationProtocolGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusIncubatorMaterialList[index].incubationProtocolGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'项目合同'">
                        <!-- :prop='"plusIncubatorMaterialList["+index+"].projectContractGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusIncubatorMaterialList[index].projectContractGuidPreview" :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].projectContractGuid'"
                          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].projectContractGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].projectContractGuid`)"
                          :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].projectContractGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusIncubatorMaterialList[index].projectContractGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusIncubatorMaterialList[index].projectContractGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'工商档案机读材料'">
                        <!--  :prop='"plusIncubatorMaterialList["+index+"].gsdajdcl"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusIncubatorMaterialList[index].businessArchivesMachineReadGuidPreview" :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].businessArchivesMachineReadGuid'"
                          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`,)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)"
                          :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusIncubatorMaterialList[index].businessArchivesMachineReadGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusIncubatorMaterialList[index].businessArchivesMachineReadGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'资金到位证明材料'">
                        <!--  :prop='"plusIncubatorMaterialList["+index+"].zjdwda"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusIncubatorMaterialList[index].proofOfFundsGuidPreview" :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].proofOfFundsGuid'"
                          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].proofOfFundsGuid`)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].proofOfFundsGuid`)"
                          :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].proofOfFundsGuid`)' :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusIncubatorMaterialList[index].proofOfFundsGuidPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusIncubatorMaterialList[index].proofOfFundsGuidPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                      <Col span="12">
                      <FormItem :label="'孵化器'+(index+1)+'补充材料'">
                        <!--  :prop='"plusIncubatorMaterialList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                        <!-- <Upload :show-upload-list="false" :default-file-list="form.plusIncubatorMaterialList[index].otherFileGuidListPreview" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                          :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].otherFileGuidList`,true)"
                          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
                        </Upload> -->
                        <div class="_link" v-for="file in form.plusIncubatorMaterialList[index].otherFileGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                          <Icon :type="file.name | fileType" />
                          {{file.name}}
                        </div>
                        <span class='_noLink' v-if="form.plusIncubatorMaterialList[index].otherFileGuidListPreview.length<1">无</span>

                      </FormItem>
                      </Col>
                    </Row>
                  </template>
                </Panel>
              </Collapse>
            </template>
          </ListItemMeta>
        </ListItem>
      </List>
      </Col>
    </Row>
  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      collapse1: ['collapse10'],
      collapse2: ['collapse20'],
      collapse3: ['collapse30'],
      collapse4: ['collapse40'],
      collapse5: ['collapse50'],
      count: 0, //操作
      uploadData: {},

      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (val < this.current) {
        // this.$emit('next', val)
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'])
          return
        }
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'])
          return
        }
        if (!this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['申请人基本信息'])
          return
        }
        if (this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        return
      }
      //下一步
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        await _this.$emit('submit', '/api/services/app/JZZJFApi/SaveAppPlusInfo', 0)
        this.$Modal.confirm({
          title: '请确认',
          content: `<p>个人身份证与证书信息一致</p>`,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            // 是 直接提交
            this.$emit('submit', '/api/services/app/JZZJFApi/SubmitApplication', 1, '提交成功')
          },
          onCancel: () => {
            //否，个人信息变更
            this.$emit('next', _this.current_index + 1)
          },
        })
      })
    },
    submit(name, type) {
      //type==true时暂存
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$Modal.confirm({
          title: '请确认',
          content: `<p>是否提交信息</p>`,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            _this.$emit('submit')
          },
        })
      })
    },
    submitStore() {
      this.$emit('submit', '/api/services/app/JZZJFApi/TempSaveAppPlusInfo', false, '暂存成功')
    },
    addChild(property, collapse_index) {
      this[collapse_index].push(collapse_index + this[collapse_index].length)
      this.$emit('addChild', property, collapse_index)
    },
    delChild(property, index) {
      this.$emit('delChild', property, index)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$forceUpdate()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      try {
        this.$refs[property][0].clearFiles()
      } catch (error) {}
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
  },
}
</script>